module.exports = __webpack_public_path__ + "img/choose_receipt3.49f85e51.png";